import { Chart } from "@scuf/charts";
import { Card } from "@scuf/common";
import { useEffect, useState } from "react";
import { TostadorFetching } from "../../../class/fetchTostador";
import { plotBackground } from "../../../config/colors";
import { useDate } from "../../../hooks/useDate";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";


export default function TotalizadorEfluenteTratado() {
  const initialFetch = new TostadorFetching().setIdSeccion(2).setSecuencia(8);

  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Custom hook que nos ayuda a extraer la fecha inicial y final
  const { setDateHook, fullDate } = useDate();

  const [totalizadorEfluenteDiario, setTotalizadorEfluenteDiario] =
    useState(defaultObject);
  const [totalizadorEfluenteTurnoA, setTotalizadorEfluenteTurnoA] =
    useState(defaultObject);
  const [totalizadorEfluenteTurnoB, setTotalizadorEfluenteTurnoB] =
    useState(defaultObject);

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetch);

      populateTotalizadorEfluentesDiario(data);
      populateTotalizadorEfluentesTurnoA(data);
      populateTotalizadorEfluentesTurnoB(data);
      setDateHook(data, "Totalizador Efluente Diario");
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateTotalizadorEfluentesDiario(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Totalizador Efluente Diario"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setTotalizadorEfluenteDiario({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTotalizadorEfluentesTurnoA(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Totalizador Efluente Turno A"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setTotalizadorEfluenteTurnoA({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTotalizadorEfluentesTurnoB(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Totalizador Efluente Turno B"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setTotalizadorEfluenteTurnoB({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Totalizador de Efluente Tratado"}
            subtitle={"Periodo " + fullDate()}
          >
            {/** -------------------------------- Totalizador Efluente Diario --------------------------------------- */}
            <Chart.Area
              name="Totalizador Efluente Diario"
              data={totalizadorEfluenteDiario.value}
              yAxis={0}
            />

            {/** -------------------------------- Totalizador Efluente Turno A --------------------------------------- */}
            <Chart.Area
              name="Totalizador Efluente Turno A"
              data={totalizadorEfluenteTurnoA.value}
              yAxis={0}
            />

            {/** -------------------------------- Totalizador Efluente Turno B --------------------------------------- */}
            <Chart.Area
              name="Totalizador Efluente Turno B"
              data={totalizadorEfluenteTurnoB.value}
              yAxis={0}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={totalizadorEfluenteDiario.fecha} />

            <Chart.YAxis
              labelSuffix=" m3"
              title="Caudal Día, m3"
              lineWidth={2}
              lineColor="white"
              min={0}
            />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
